import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight, FiChevronRight } from "react-icons/fi";
import { TRAINING_CATEGORIES } from "../../data/trainingData";

/**
 * ACE-style pathway list: clean linked rows with icons, not dense card grid.
 */
const TrainingCategories = () => {
  return (
    <section
      className="bg-gray-50 py-14 md:py-20 px-4 sm:px-6 lg:px-8"
      aria-label="Training categories"
      id="training-categories"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-10 md:mb-14"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Training Pathways
          </h2>
          <div
            className="w-20 h-1 bg-[#F86624] mx-auto rounded-full mb-5"
            aria-hidden="true"
          />
          <p className="text-gray-600 text-base md:text-lg">
            We offer physical, online, and blended learning courses for students
            and professionals across the following categories.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <ul className="divide-y divide-gray-100 list-none">
            {TRAINING_CATEGORIES.map((category, index) => {
              const Icon = category.icon;
              return (
                <motion.li
                  key={category.id}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.35, delay: index * 0.04 }}
                >
                  <Link
                    to={category.link}
                    className="group flex items-start gap-4 px-5 sm:px-7 py-4 sm:py-5 hover:bg-[var(--bg-primary)]/[0.04] transition-colors"
                  >
                    <span className="mt-0.5 w-10 h-10 rounded-lg bg-[var(--bg-primary)]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[var(--bg-primary)] transition-colors">
                      <Icon
                        size={18}
                        className="text-[var(--bg-primary)] group-hover:text-white transition-colors"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2 text-base font-bold text-gray-900 group-hover:text-[var(--bg-primary)] transition-colors">
                        {category.title}
                        <FiChevronRight
                          size={16}
                          className="text-gray-300 group-hover:text-[#F86624] transition-colors hidden sm:inline"
                          aria-hidden="true"
                        />
                      </span>
                      <span className="block text-sm text-gray-600 mt-1 leading-relaxed">
                        {category.description}
                      </span>
                    </span>
                    <FiArrowRight
                      size={16}
                      className="text-gray-300 group-hover:text-[#F86624] transition-colors flex-shrink-0 mt-2 sm:hidden"
                      aria-hidden="true"
                    />
                  </Link>
                </motion.li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TrainingCategories;
